exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app,body,html{height:100%;margin:0}.background-color,.v-app-bar,.v-main{background-color:#eee!important}.main-footer{position:-webkit-sticky;position:sticky;bottom:0;right:0;left:0;z-index:1}.main-content{-webkit-box-flex:1;-ms-flex:1;flex:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;overflow:hidden;padding-bottom:4px}.scrollable-content{-webkit-box-flex:1;-ms-flex:1;flex:1;overflow-y:auto;padding-bottom:45px}", ""]);

// exports
